import api from "@/services/api/users/api-users";
import {UserModel} from "@/app/exercise/modules/users/core/models/UserModel";

export class UsersService {
  constructor(authSvc) {
    this.authSvc = authSvc;
  }

  async list(query) {
    try {
      const res = await api.list(query);
      if(!res) throw new Error('Something went wrong and list is not loading. Please, reload page or try again later.');
      return {
        results: res.results.map( item => new UserModel(item) ),
        pagination: {
          count: res.count,
        }
      };
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async remove(item) {
    try {
      return await api.remove(item.id);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async changePassword(id, password) {
    try {
      return await api.changePassword(id, password);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async loadUserExams(query) {
    try {
      const res = await api.loadUserExams(query);
      if(!res) throw new Error('Something went wrong and users exams list is not loading. Please, reload page or try again later.');
      return {
        results: res.results,
        pagination: {
          count: res.count,
        }
      };
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async loadUserCbrExams(query) {
    try {
      const res = await api.loadUserCbrExams(query);
      if(!res) throw new Error('Something went wrong and cbr exams list is not loading. Please, reload page or try again later.');
      return {
        results: res.results,
        pagination: {
          count: res.count,
        }
      };
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
